module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"card.progress_service.title":"งานซ่อมที่ค้างอยู่","card.payment_service.title":"งานซ่อมค้างจ่าย","card.recent_service.title":"งานซ่อมล่าสุด","see_more.label":"@:common.see_more"}}')
  delete Component.options._Ctor
}
